var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconSocialFacebook = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Icon-SocialFacebook"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M10.1611 3.45312C9.33428 3.45312 9.09524 3.81821 9.09524 4.62344V5.95925H11.3006L11.0796 8.11735H9.0961V14.6667H6.44948V8.11735H4.6665V5.95925H6.44948V4.66012C6.44948 2.48326 7.33111 1.33341 9.79095 1.33341C10.3064 1.3322 10.8215 1.36269 11.3332 1.42468V3.45568L10.1611 3.45312Z",
  fill: "#142138"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconSocialFacebook);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9Ikljb24tU29jaWFsRmFjZWJvb2siPgo8cGF0aCBpZD0iVmVjdG9yIiBkPSJNMTAuMTYxMSAzLjQ1MzEyQzkuMzM0MjggMy40NTMxMiA5LjA5NTI0IDMuODE4MjEgOS4wOTUyNCA0LjYyMzQ0VjUuOTU5MjVIMTEuMzAwNkwxMS4wNzk2IDguMTE3MzVIOS4wOTYxVjE0LjY2NjdINi40NDk0OFY4LjExNzM1SDQuNjY2NVY1Ljk1OTI1SDYuNDQ5NDhWNC42NjAxMkM2LjQ0OTQ4IDIuNDgzMjYgNy4zMzExMSAxLjMzMzQxIDkuNzkwOTUgMS4zMzM0MUMxMC4zMDY0IDEuMzMyMiAxMC44MjE1IDEuMzYyNjkgMTEuMzMzMiAxLjQyNDY4VjMuNDU1NjhMMTAuMTYxMSAzLjQ1MzEyWiIgZmlsbD0iIzE0MjEzOCIvPgo8L2c+Cjwvc3ZnPgo=";